// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Barlow-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Barlow-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Nelphim.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/Home.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Barlow";
  src: local("Barlow"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "BarlowBold";
  src: local("BarlowBold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}
@font-face {
  font-family: "Nelphim";
  src: local("Nelphim"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}

.wrapper-bg {
  background-color: #cbbaa6;
}
.wrapper {
  display: block;
  position: relative;
  padding-top: 30px;
  padding-bottom: 60px;
  height: calc(100vh - 60px);
  width: 100%;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.bg-image {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
 /* <------ */
  background-repeat: no-repeat;
  background-position: center center;
  width: calc(100% - 120px);
  height: 100%;
  margin-left: 60px;
  border-radius: 30px;
}
.hero-col {
  display: grid;
  grid-template-columns: auto auto;
  gap: 10px;
  height: 100%;
  align-items: center;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
 }
  100% {
    opacity: 1;
 }
}
.hero-bg-col-1 {
  padding: 0px 0px 0px 60px;
  margin-bottom: 15%;
  animation: fadeIn 5s;
}
.hero-bg-col-1 .header-title-left {
  font-family: "Nelphim";
  font-size: 6em;
  color: white;
}
.hero-bg-col-1 .header-subtitle {
  color: #fff;
}
.header-button {
  border: 1px solid #fff;
  border-radius: 20px;
  background-color: #000;
  color: #fff;
  position: absolute;
  bottom: 124px;
  left: 124px;
  display: flex;
  align-items: center;
}
.hero-bg-col-2 {
  top: 35%;
  padding: 0px 90px 0px 0px;
  right: 0px;
  text-align: right;
  animation: fadeIn 5s;
}
.hero-bg-col-2 .header-title-right {
  font-family: "Nelphim";
  font-size: 6em;
  color: white;
}
.hero-bg-col-2 .header-subtitle {
  color: #fff;
}
.section-intro {
  display: flex;
  max-width: 1366px;
  padding: 30px 0px;
  margin-left: auto;
  margin-right: auto;
}
.section-intro .section-item-1 {
  width: 45%;
  padding: 30px 30px 30px 60px;
}
.section-intro .section-item-2 {
  width: 55%;
  padding: 30px 60px 30px 30px;
}
.section-feature {
  max-width: 1366px;
  padding: 60px 0px 0px 0px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  overflow: auto;
}
.section-feature .section-feature-title-group {
  text-align: center;
  margin-bottom: 60px;
}
.section-feature .section-feature-title-group .section-tag {
  justify-content: center;
}
.section-feature .section-feature-title-group .section-feature-title {
  max-width: 40%;
  margin-left: auto;
  margin-right: auto;
}
.section-feature .section-feature-title-group .section-feature-desc {
  margin-top: 30px;
  max-width: 40%;
  margin-left: auto;
  margin-right: auto;
}
.section-feature .section-item-1 {
  width: 45%;
  padding: 30px 30px 30px 60px;
}
.section-feature .section-item-2 {
  width: 55%;
  padding: 30px 60px 30px 30px;
}
.section-button {
  margin-top: 60px;
}
.section-value {
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  padding: 120px 0px;
}
.section-value .section-item-1 {
  width: 40%;
  padding: 0px 0px 0px 60px;
}
.section-value .section-item-2 {
  width: 60%;
  padding: 0px 60px 0px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-value-group-web {
  display: block;
  margin-top: 30px;
}
.btn-value-group-mobile {
  display: none;
}
.img-value-web {
  display: block;
  width: 100%;
}
.btn-value {
  text-align: left;
  padding: 30px;
  border-radius: 20px;
  border: 1px solid #f1f1f1;
  background-color: transparent;
  margin-bottom: 30px;
  color: #333;
}
.btn-value .section-detail-value .main {
  margin-bottom: 12px;
}
.btn-value:last-child {
  margin-bottom: 0px;
}
.btn-value:hover {
  background-color: #7ba7c2;
}
.btn-value:hover .section-detail-value .main {
  color: #fcfcfc;
}
.btn-value:hover .section-detail-value .section-detail-btn {
  color: #ecebe6;
}
.img-value {
  display: block;
  border-radius: 30px;
  width: 100%;
}
.btn-hero-group {
  position: absolute;
  margin-top: -10%;
  left: 124px;
  display: flex;
  align-items: center;
}
.btn-hero {
  background: rgba(252, 252, 252, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  border: 1px solid #ecebe6;
  color: #fcfcfc;
  border-radius: 20px;
  position: relative;
  z-index: 20;
  transition: 0.3s all ease-in-out;
  display: flex;
  align-items: center;
  width: max-content;
}
.btn-hero .btn-text {
  padding: 10px 0px 10px 24px;
}
.btn-hero:before {
  border-radius: 20px;
  background: rgba(252, 252, 252, 0.2);
  position: absolute;
  display: flex;
  align-items: center;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: 0.3s all ease-in-out;
  z-index: -1;
}
.btn-hero svg {
  width: 20px;
  height: 20px;
  position: relative;
  padding: 0em 0em 0em 10px;
}
.btn-hero:hover {
  background-color: unset;
  left: 0px;
  padding-left: 54px;
  color: #fff;
}
.btn-hero:hover .btn-text {
  padding: 10px 0px;
}
.btn-hero:hover svg {
  position: absolute;
  left: 8px;
  bottom: 10px;
}
.btn-hero:hover:before {
  width: 100%;
}
.btn-section {
  display: flex;
  align-items: center;
}
.section-feature-cards {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.wrap {
  width: 100%;
  padding: 0px 60px;
  display: flex;
  justify-content: space-between;
}
.el-group {
  width: 32%;
}
.el {
  position: relative;
  margin: 0px 12px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 30px;
}
.el p {
  display: none;
}
.el .el-image {
  transform-origin: 50% 50;
  width: 100%;
  transform: scale(1);
  transition: transform 0.3s ease-out;
  border-radius: 30px;
}
.el:hover {
  transform: scale(1);
  background-color: #fff;
  padding-top: 30px;
}
.el-group:hover p {
  display: flex;
  justify-content: space-between;
  padding: 0px 24px;
  color: #777;
}
.el-group:hover .el-image {
  padding: 24px;
  width: 100%;
  width: -webkit-fill-available;
  transition: transform 0.3s ease-in;
}
.el-image-shadow {
  position: relative;
  margin: 0px 12px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 30px;
}
.shadow {
  mask-image: linear-gradient(transparent, transparent, transparent, rgba(0, 0, 0, 0.5));
  transform-origin: 50% 50;
  width: 100%;
  transform: scale(1);
  transition: transform 0.3s ease-out;
  border-radius: 30px;
  transform: rotateX(180deg);
}
.el-group:hover .shadow {
  padding: 0px 24px;
  width: 100%;
  width: -webkit-fill-available;
  transition: transform 0.3s ease-in;
  border-radius: 30px;
}
.el-button-group {
  position: absolute;
  bottom: 16px;
  left: 16px;
}
.el-group:hover .el-button-group {
  bottom: 42px;
  left: 42px;
}
.el-button {
  padding: 10px 20px;
  border-radius: 20px;
  border: 1px solid #ecebe6;
  background: rgba(252, 252, 252, 0.2);
  backdrop-filter: blur(10px);
  color: #fcfcfc;
}
.section-feature-button {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  position: absolute;
  margin-top: -200px;
  width: 100%;
}
.wellness-section {
  display: flex;
  max-width: 1366px;
  padding: 30px 60px;
  margin-left: auto;
  margin-right: auto;
}
.parallax-section {
  border-bottom-right-radius: 36px;
  border-bottom-left-radius: 36px;
  background: #ecebe6;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
}
.parallax {
  min-height: 100vh;
  position: relative;
}
.parallax-web {
  display: block;
}
.parallax-mobile {
  display: none;
}
.parallax-content {
  position: absolute;
  width: calc(100% - 120px);
  height: 100vh;
  overflow: scroll;
  padding: 60px 60px;
}
.parallax-content::-webkit-scrollbar {
  display: none;
}
.parallax-content-group {
  display: block;
  max-width: 1366px;
  width: calc(100% - 120px);
  margin-left: auto;
  margin-right: auto;
}
.parallax-image-1, .parallax-image-2, .parallax-image-3, .parallax-image-4, .parallax-image-5, .parallax-image-6 {
  width: 100%;
}
.parallax-text-section-1, .parallax-text-section-2, .parallax-text-section-3, .parallax-text-section-4, .parallax-text-section-5, .parallax-text-section-6 {
  width: 100%;
}
.parallax-image-url {
  border-radius: 30px;
  width: 25%;
  margin-bottom: 66px;
}
.parallax-text {
  width: 25%;
  border-radius: 30px;
  border: 1px solid #ecebe6;
  box-shadow: 0px 119px 33px 0px rgba(135, 135, 135, 0), 0px 76px 31px 0px rgba(135, 135, 135, 0.01), 0px 43px 26px 0px rgba(135, 135, 135, 0.02), 0px 19px 19px 0px rgba(135, 135, 135, 0.04), 0px 5px 10px 0px rgba(135, 135, 135, 0.04);
  backdrop-filter: blur(10px);
  background: rgba(252, 252, 252, 0.6);
  padding: 30px;
  display: block;
  color: #777;
}
.parallax-title {
  font-family: "BarlowBold";
  margin-bottom: 12px;
  width: 100%;
  color: #333;
}
.parallax-content-1 {
  padding-top: 55vh;
}
.parallax-image-url-1 {
  margin-left: 25%;
}
.parallax-text-1 {
  margin-left: 10%;
}
.parallax-image-url-2 {
  margin-left: 60%;
}
.parallax-text-2 {
  margin-left: 70%;
}
.parallax-image-url-3 {
  margin-left: 20%;
}
.parallax-text-3 {
  margin-left: 30%;
}
.parallax-image-url-4 {
  margin-left: 65%;
}
.parallax-text-4 {
  margin-left: 70%;
}
.parallax-content-group.parallax-content-5 {
  margin-top: -10%;
}
.parallax-image-url-5 {
  margin-left: 60px;
}
.parallax-text-5 {
  margin-left: 10%;
}
.parallax-content-group.parallax-content-6 {
  padding-bottom: 60px;
}
.parallax-image-url-6 {
  width: 15%;
  margin-left: 85%;
}
.parallax-text-6 {
  margin-left: 65%;
  margin-bottom: 30px;
}
.react-photo-album--image {
  border-radius: 30px;
}
.gallery-section {
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  padding-top: 60px;
  padding-bottom: 60px;
  overflow: auto;
}
.section-title-gallery-group {
  width: calc(100% - 120px);
  padding-left: 60px;
  padding-right: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fcfcfc;
  padding-bottom: 60px;
}
.section-title-gallery-group .section-title-gallery {
  width: 50%;
}
.section-title-gallery-group .section-desc-gallery {
  width: 50%;
}
.react-photo-album--columns {
  justify-content: space-between;
  padding: 0px 60px;
}
.section-gallery-button {
  color: #fcfcfc;
  text-align: center;
  margin-top: 60px;
}
.gallery-web {
  display: block;
  width: 100%;
  overflow: hidden;
}
.gallery-mobile {
  display: none;
}
.gallery-button {
  margin-top: 12px;
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/home_web.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4EAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,gFAA2E;AAC7E;AACA;EACE,sBAAsB;EACtB,8EAAoE;AACtE;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mDAAsC;EACtC,sBAAsB;CACvB,YAAY;EACX,4BAA4B;EAC5B,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;IACE,UAAU;CACb;EACC;IACE,UAAU;CACb;AACD;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,yBAAyB;EACzB,UAAU;EACV,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,sFAAsF;EACtF,wBAAwB;EACxB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;EACnB,uFAAuF;AACzF;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,wOAAwO;EACxO,2BAA2B;EAC3B,oCAAoC;EACpC,aAAa;EACb,cAAc;EACd,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB","sourcesContent":["@font-face {\n  font-family: \"Barlow\";\n  src: local(\"Barlow\"), url(\"../fonts/Barlow-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"BarlowBold\";\n  src: local(\"BarlowBold\"), url(\"../fonts/Barlow-Medium.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Nelphim\";\n  src: local(\"Nelphim\"), url(\"../fonts/Nelphim.woff2\") format(\"woff2\");\n}\n\n.wrapper-bg {\n  background-color: #cbbaa6;\n}\n.wrapper {\n  display: block;\n  position: relative;\n  padding-top: 30px;\n  padding-bottom: 60px;\n  height: calc(100vh - 60px);\n  width: 100%;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n}\n.bg-image {\n  background: url(\"../images/Home.webp\");\n  background-size: cover;\n /* <------ */\n  background-repeat: no-repeat;\n  background-position: center center;\n  width: calc(100% - 120px);\n  height: 100%;\n  margin-left: 60px;\n  border-radius: 30px;\n}\n.hero-col {\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 10px;\n  height: 100%;\n  align-items: center;\n}\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n }\n  100% {\n    opacity: 1;\n }\n}\n.hero-bg-col-1 {\n  padding: 0px 0px 0px 60px;\n  margin-bottom: 15%;\n  animation: fadeIn 5s;\n}\n.hero-bg-col-1 .header-title-left {\n  font-family: \"Nelphim\";\n  font-size: 6em;\n  color: white;\n}\n.hero-bg-col-1 .header-subtitle {\n  color: #fff;\n}\n.header-button {\n  border: 1px solid #fff;\n  border-radius: 20px;\n  background-color: #000;\n  color: #fff;\n  position: absolute;\n  bottom: 124px;\n  left: 124px;\n  display: flex;\n  align-items: center;\n}\n.hero-bg-col-2 {\n  top: 35%;\n  padding: 0px 90px 0px 0px;\n  right: 0px;\n  text-align: right;\n  animation: fadeIn 5s;\n}\n.hero-bg-col-2 .header-title-right {\n  font-family: \"Nelphim\";\n  font-size: 6em;\n  color: white;\n}\n.hero-bg-col-2 .header-subtitle {\n  color: #fff;\n}\n.section-intro {\n  display: flex;\n  max-width: 1366px;\n  padding: 30px 0px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.section-intro .section-item-1 {\n  width: 45%;\n  padding: 30px 30px 30px 60px;\n}\n.section-intro .section-item-2 {\n  width: 55%;\n  padding: 30px 60px 30px 30px;\n}\n.section-feature {\n  max-width: 1366px;\n  padding: 60px 0px 0px 0px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n  overflow: auto;\n}\n.section-feature .section-feature-title-group {\n  text-align: center;\n  margin-bottom: 60px;\n}\n.section-feature .section-feature-title-group .section-tag {\n  justify-content: center;\n}\n.section-feature .section-feature-title-group .section-feature-title {\n  max-width: 40%;\n  margin-left: auto;\n  margin-right: auto;\n}\n.section-feature .section-feature-title-group .section-feature-desc {\n  margin-top: 30px;\n  max-width: 40%;\n  margin-left: auto;\n  margin-right: auto;\n}\n.section-feature .section-item-1 {\n  width: 45%;\n  padding: 30px 30px 30px 60px;\n}\n.section-feature .section-item-2 {\n  width: 55%;\n  padding: 30px 60px 30px 30px;\n}\n.section-button {\n  margin-top: 60px;\n}\n.section-value {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 120px 0px;\n}\n.section-value .section-item-1 {\n  width: 40%;\n  padding: 0px 0px 0px 60px;\n}\n.section-value .section-item-2 {\n  width: 60%;\n  padding: 0px 60px 0px 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.btn-value-group-web {\n  display: block;\n  margin-top: 30px;\n}\n.btn-value-group-mobile {\n  display: none;\n}\n.img-value-web {\n  display: block;\n  width: 100%;\n}\n.btn-value {\n  text-align: left;\n  padding: 30px;\n  border-radius: 20px;\n  border: 1px solid #f1f1f1;\n  background-color: transparent;\n  margin-bottom: 30px;\n  color: #333;\n}\n.btn-value .section-detail-value .main {\n  margin-bottom: 12px;\n}\n.btn-value:last-child {\n  margin-bottom: 0px;\n}\n.btn-value:hover {\n  background-color: #7ba7c2;\n}\n.btn-value:hover .section-detail-value .main {\n  color: #fcfcfc;\n}\n.btn-value:hover .section-detail-value .section-detail-btn {\n  color: #ecebe6;\n}\n.img-value {\n  display: block;\n  border-radius: 30px;\n  width: 100%;\n}\n.btn-hero-group {\n  position: absolute;\n  margin-top: -10%;\n  left: 124px;\n  display: flex;\n  align-items: center;\n}\n.btn-hero {\n  background: rgba(252, 252, 252, 0.2);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  border: 1px solid #ecebe6;\n  color: #fcfcfc;\n  border-radius: 20px;\n  position: relative;\n  z-index: 20;\n  transition: 0.3s all ease-in-out;\n  display: flex;\n  align-items: center;\n  width: max-content;\n}\n.btn-hero .btn-text {\n  padding: 10px 0px 10px 24px;\n}\n.btn-hero:before {\n  border-radius: 20px;\n  background: rgba(252, 252, 252, 0.2);\n  position: absolute;\n  display: flex;\n  align-items: center;\n  content: \"\";\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transition: 0.3s all ease-in-out;\n  z-index: -1;\n}\n.btn-hero svg {\n  width: 20px;\n  height: 20px;\n  position: relative;\n  padding: 0em 0em 0em 10px;\n}\n.btn-hero:hover {\n  background-color: unset;\n  left: 0px;\n  padding-left: 54px;\n  color: #fff;\n}\n.btn-hero:hover .btn-text {\n  padding: 10px 0px;\n}\n.btn-hero:hover svg {\n  position: absolute;\n  left: 8px;\n  bottom: 10px;\n}\n.btn-hero:hover:before {\n  width: 100%;\n}\n.btn-section {\n  display: flex;\n  align-items: center;\n}\n.section-feature-cards {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.wrap {\n  width: 100%;\n  padding: 0px 60px;\n  display: flex;\n  justify-content: space-between;\n}\n.el-group {\n  width: 32%;\n}\n.el {\n  position: relative;\n  margin: 0px 12px;\n  box-sizing: border-box;\n  text-align: center;\n  border-radius: 30px;\n}\n.el p {\n  display: none;\n}\n.el .el-image {\n  transform-origin: 50% 50;\n  width: 100%;\n  transform: scale(1);\n  transition: transform 0.3s ease-out;\n  border-radius: 30px;\n}\n.el:hover {\n  transform: scale(1);\n  background-color: #fff;\n  padding-top: 30px;\n}\n.el-group:hover p {\n  display: flex;\n  justify-content: space-between;\n  padding: 0px 24px;\n  color: #777;\n}\n.el-group:hover .el-image {\n  padding: 24px;\n  width: 100%;\n  width: -webkit-fill-available;\n  transition: transform 0.3s ease-in;\n}\n.el-image-shadow {\n  position: relative;\n  margin: 0px 12px;\n  box-sizing: border-box;\n  text-align: center;\n  border-radius: 30px;\n}\n.shadow {\n  mask-image: linear-gradient(transparent, transparent, transparent, rgba(0, 0, 0, 0.5));\n  transform-origin: 50% 50;\n  width: 100%;\n  transform: scale(1);\n  transition: transform 0.3s ease-out;\n  border-radius: 30px;\n  transform: rotateX(180deg);\n}\n.el-group:hover .shadow {\n  padding: 0px 24px;\n  width: 100%;\n  width: -webkit-fill-available;\n  transition: transform 0.3s ease-in;\n  border-radius: 30px;\n}\n.el-button-group {\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n}\n.el-group:hover .el-button-group {\n  bottom: 42px;\n  left: 42px;\n}\n.el-button {\n  padding: 10px 20px;\n  border-radius: 20px;\n  border: 1px solid #ecebe6;\n  background: rgba(252, 252, 252, 0.2);\n  backdrop-filter: blur(10px);\n  color: #fcfcfc;\n}\n.section-feature-button {\n  display: flex;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  margin-top: -200px;\n  width: 100%;\n}\n.wellness-section {\n  display: flex;\n  max-width: 1366px;\n  padding: 30px 60px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.parallax-section {\n  border-bottom-right-radius: 36px;\n  border-bottom-left-radius: 36px;\n  background: #ecebe6;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;\n}\n.parallax {\n  min-height: 100vh;\n  position: relative;\n}\n.parallax-web {\n  display: block;\n}\n.parallax-mobile {\n  display: none;\n}\n.parallax-content {\n  position: absolute;\n  width: calc(100% - 120px);\n  height: 100vh;\n  overflow: scroll;\n  padding: 60px 60px;\n}\n.parallax-content::-webkit-scrollbar {\n  display: none;\n}\n.parallax-content-group {\n  display: block;\n  max-width: 1366px;\n  width: calc(100% - 120px);\n  margin-left: auto;\n  margin-right: auto;\n}\n.parallax-image-1, .parallax-image-2, .parallax-image-3, .parallax-image-4, .parallax-image-5, .parallax-image-6 {\n  width: 100%;\n}\n.parallax-text-section-1, .parallax-text-section-2, .parallax-text-section-3, .parallax-text-section-4, .parallax-text-section-5, .parallax-text-section-6 {\n  width: 100%;\n}\n.parallax-image-url {\n  border-radius: 30px;\n  width: 25%;\n  margin-bottom: 66px;\n}\n.parallax-text {\n  width: 25%;\n  border-radius: 30px;\n  border: 1px solid #ecebe6;\n  box-shadow: 0px 119px 33px 0px rgba(135, 135, 135, 0), 0px 76px 31px 0px rgba(135, 135, 135, 0.01), 0px 43px 26px 0px rgba(135, 135, 135, 0.02), 0px 19px 19px 0px rgba(135, 135, 135, 0.04), 0px 5px 10px 0px rgba(135, 135, 135, 0.04);\n  backdrop-filter: blur(10px);\n  background: rgba(252, 252, 252, 0.6);\n  padding: 30px;\n  display: block;\n  color: #777;\n}\n.parallax-title {\n  font-family: \"BarlowBold\";\n  margin-bottom: 12px;\n  width: 100%;\n  color: #333;\n}\n.parallax-content-1 {\n  padding-top: 55vh;\n}\n.parallax-image-url-1 {\n  margin-left: 25%;\n}\n.parallax-text-1 {\n  margin-left: 10%;\n}\n.parallax-image-url-2 {\n  margin-left: 60%;\n}\n.parallax-text-2 {\n  margin-left: 70%;\n}\n.parallax-image-url-3 {\n  margin-left: 20%;\n}\n.parallax-text-3 {\n  margin-left: 30%;\n}\n.parallax-image-url-4 {\n  margin-left: 65%;\n}\n.parallax-text-4 {\n  margin-left: 70%;\n}\n.parallax-content-group.parallax-content-5 {\n  margin-top: -10%;\n}\n.parallax-image-url-5 {\n  margin-left: 60px;\n}\n.parallax-text-5 {\n  margin-left: 10%;\n}\n.parallax-content-group.parallax-content-6 {\n  padding-bottom: 60px;\n}\n.parallax-image-url-6 {\n  width: 15%;\n  margin-left: 85%;\n}\n.parallax-text-6 {\n  margin-left: 65%;\n  margin-bottom: 30px;\n}\n.react-photo-album--image {\n  border-radius: 30px;\n}\n.gallery-section {\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n  padding-top: 60px;\n  padding-bottom: 60px;\n  overflow: auto;\n}\n.section-title-gallery-group {\n  width: calc(100% - 120px);\n  padding-left: 60px;\n  padding-right: 60px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #fcfcfc;\n  padding-bottom: 60px;\n}\n.section-title-gallery-group .section-title-gallery {\n  width: 50%;\n}\n.section-title-gallery-group .section-desc-gallery {\n  width: 50%;\n}\n.react-photo-album--columns {\n  justify-content: space-between;\n  padding: 0px 60px;\n}\n.section-gallery-button {\n  color: #fcfcfc;\n  text-align: center;\n  margin-top: 60px;\n}\n.gallery-web {\n  display: block;\n  width: 100%;\n  overflow: hidden;\n}\n.gallery-mobile {\n  display: none;\n}\n.gallery-button {\n  margin-top: 12px;\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
